import { icons } from "assets";
import { Header } from "Components/header/Header";
import ActionCard from "Components/shared/cards/ActionCard";

import WalletCard, { HomeWalletCard } from "Components/shared/cards/WalletCard";
import Hidden from "Components/shared/hidden";
import Text from "Components/shared/text";
import React, { startTransition, useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useGetWalletBalance } from "services/walletService";
import { convertToCurrency } from "utils/stringServices";
import styles from "./wallet.module.css";

const WalletHome = () => {
  const navigate = useNavigate();
  
  const {data, isLoading, isError, isSuccess} = useGetWalletBalance();
  const queryClient = useQueryClient();
  const onRefreshHandler = (cb) => {
    queryClient.invalidateQueries("wallet-balance");
    let millis = 0;
    const timerId = setInterval(() => {
     
      if(isSuccess || isError || millis/1000 > 30){
        cb();
       clearInterval(timerId)
      }
      millis += 500
    }, 500)
  }
  const walletBalances = data?.data || {}

  return (
    <div className={styles.root}>
      <div className="w-full row-start space-between">
        <div>
          <Text variant="xl" tag="h1" style={{ fontWeight: "700" }}>
            Wallet
          </Text>
          <Text variant="sm" color="secondary">
            View all your wallet balance
          </Text>
        </div>
        <Header hidden />
        </div>
      <div className={styles.WalletHome}>
        <Hidden smDown>
          <div className={`row-start ${styles.WalletCards}`}>
            <HomeWalletCard
              data={{ naira: convertToCurrency(walletBalances.total?.ngn || 0), 
                 dollar: convertToCurrency(walletBalances.total?.usd || 0), 
                 euro: convertToCurrency(walletBalances.total?.eur || 0) }}
              onRefresh={onRefreshHandler}
            />
            <WalletCard
              background="rgba(32, 191, 107, 0.1)"
              symbol="naira"
              amount={convertToCurrency(walletBalances.ngn)}
              onRefresh={onRefreshHandler}
              viewable
              onClick={() => startTransition(() => navigate("naira"))}
            />
            <WalletCard
              background="rgba(1, 105, 255, 0.1)"
              symbol="dollar"
              amount={convertToCurrency(walletBalances.usd || 0)}
              onRefresh={onRefreshHandler}
              viewable
              onClick={() => startTransition(() => navigate("dollar"))}
            />
            <WalletCard
              background="#E2E8F0"
              symbol="euro"
              onRefresh={onRefreshHandler}
              amount={ convertToCurrency(walletBalances.eur || 0) }
              viewable
              onClick={() => startTransition(() => navigate("euro"))}
            />
          </div>
        </Hidden>
        <Hidden smUp>
          <div className={`row-start ${styles.WalletCards}`}>
            <HomeWalletCard
              data={{ naira: convertToCurrency(walletBalances.total?.ngn || 0),
                 dollar: convertToCurrency(walletBalances.total?.usd ||0), euro: convertToCurrency(walletBalances.total?.eur ||0 )}}
              onRefresh={onRefreshHandler}
            />
            <WalletCard
              background="rgba(32, 191, 107, 0.1)"
              symbol="naira"
              amount={convertToCurrency(walletBalances.ngn || 0) }
              onRefresh={onRefreshHandler}
              onClick={() => startTransition(() => navigate("naira"))}
            />
            <WalletCard
              background="rgba(1, 105, 255, 0.1)"
              symbol="dollar"
              amount={convertToCurrency(walletBalances.usd || 0)}
              onRefresh={onRefreshHandler}
              onClick={() => startTransition(() => navigate("dollar"))}
            />
            <WalletCard
              background="#E2E8F0"
              symbol="euro"
              onRefresh={onRefreshHandler}
              amount={convertToCurrency(walletBalances.eur || 0)}
              onClick={() => startTransition(() => navigate("euro"))}
            />
          </div>
        </Hidden>
        <div style={{ paddingTop: "12px" }}>
          <Text
            variant="xl"
            color="secondary"
            style={{ fontWeight: 700, color: "#CBD5E1" }}
          >
            Quick actions
          </Text>
          <div className={`${styles.ActionCards}`}>
            <ActionCard
              icon={icons.swapCurrency}
              variant="secondary"
              title="Swap Currency"
              viewable
              subtitle="The App also enables users to swap between currencies"
              onClick={() => startTransition(() => navigate("swap-currency"))}
            />
            <ActionCard
              icon={icons.addColor}
              variant="primary"
              title="Make Deposit"
              viewable
              subtitle="Make a deposit into your Naira wallet via bank transfer"
              onClick={() => startTransition(() => navigate("naira/deposit"))}
            />
            <ActionCard
              icon={icons.download}
              variant="tertiary"
              title="Withdraw Money"
              viewable
              subtitle="You can make a withdrawal from your Naira wallet. "
              onClick={() => startTransition(() => navigate("naira/withdraw"))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletHome;
